import React, { useEffect, useState } from "react";
import { AiOutlineMenu, AiOutlineUser } from "react-icons/ai";
import { IoIosLogIn } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Color } from "../../Utils/styles";
function Header() {
  const { user, user_type, basket } = useSelector(state => state);
  const { pathname } = useLocation();
  const renderLink = () => {
    switch (user_type) {
      case "admin":
        return "/Admin/Dashboard";
      case "user":
      case "manager":
      case "coach":
        return "/User/Dashboard";
      default:
        return "/check";
    }
  };

  const enderLinkText = () => {
    switch (user_type) {
      case "admin":
        return { txt: "پنل مدیریت" };
      case "user":
      case "manager":
      case "coach":
        return {
          txt: "حساب کاربری",
          icon: (
            <i className="fal fa-sign-in-alt" style={{ marginLeft: "6px" }}></i>
          ),
        };
      default:
        return {
          txt: "ورود / ثبت نام",
          icon: (
            <i className="fal fa-sign-in-alt" style={{ marginLeft: "6px" }}></i>
          ),
        };
    }
  };
  const links = [
    {
      name: "نیکوتن",
      path: "/",
      key: 3,
    },

    {
      name: "استخر ها",
      path: "/pool",
      key: 2,
    },
    {
      name: "باشگاه های بدنسازی",
      path: "/gym",
      key: 4,
    },
    {
      name: "سالن های ورزشی",
      path: "/salon",
      key: 5,
    },
    // {
    //   name: "کلاس ها ورزشی",
    //   path: "/Classes/List",
    //   key: 1,
    // },
    {
      name: "مجله نیکوتن",
      path: "/weblog",
      key: 1,
    },
    {
      name: "باشگاه مشتریان",
      path: "/clup",
      key: 1,
    },
  ];
  let location = useLocation();
  const routeNames = [
    {
      path: "/roadmap",
      className: "background-gray",
      style: { boxShadow: "none !important" },
    },
    // {
    //   path: "/questions",
    //   className: "background-gray",
    //   style: { boxShadow: "none !important" },
    // },
  ];
  const headerStyle = () => {
    let res = { className: "", style: {} };
    routeNames.map(route => {
      if (route.path === location.pathname) {
        res = route;
      }
    });
    return res;
  };
  const renderFaq = () => {
    if (location.pathname == "/faq") {
      return "faq-navbar";
    }
    return "";
  };
  return (
    <header
      id="main-header"
      className={
        `${headerStyle()["className"]} main-header ${renderFaq()}`
        // +
        // (location.pathname === "/faq" ? "faq-header" : "")
      }
      style={{
        paddingBottom:
          location.pathname == "/Items" || location.pathname == "/Classes/List"
            ? "60px"
            : "0",
        ...headerStyle()["style"],
      }}
    >
      <div className="container px-0">
        <div className="inner">
          <div className="d-flex align-items-center justify-content-between">
            <div className="icons w-25 d-flex flex-column align-items-center mt-2 px-2">
              <Link to={"/"}>
                <img
                  src={
                    location.pathname == "/faq"
                      ? window.origin + "/img/nikotanwhite.png"
                      : window.origin + "/WebSide/assets/images/logo.png"
                  }
                  alt="nikotan | نیکوتن"
                />
              </Link>
            </div>
            <div
              className="links w-100 d-lg-flex d-none"
              style={{ whiteSpace: "nowrap", alignSelf: "stretch" }}
            >
              {links.map((link, key) => {
                return (
                  <Link
                    key={key}
                    to={link.path}
                    className="many  header-font-size link-header "
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignSelf: "stretch",
                      alignItems: "center",
                      borderBottom:
                        pathname == link.path
                          ? `2px solid ${Color.primary}`
                          : "none",
                      color:
                        pathname == link.path ? Color.primary : Color.black,
                    }}
                  // #707070
                  >
                    {link.name}
                  </Link>
                );
              })}
            </div>
            <div className="links-two justify-content-end w-100 d-none d-md-flex ">
              {user_type ? (
                <Link to={renderLink()}
                  className=" last-link many align-self-center d-flex align-items-center left-links">
                  {enderLinkText()["txt"]}
                  <AiOutlineUser className="ms-2" size={22} />
                </Link>
              ) : (
                <Link to={"/check"}
                  className="last-link many align-self-center d-flex align-items-center left-links">
                  ورود / ثبت نام
                  <IoIosLogIn className="ms-2" size={22} />
                </Link>
              )}
            </div>

            <div className="ms-auto navbar py-0 navbar-expand-lg navbar-light d-table-header-group rounded-3">
              <button
                className="navbar-toggler bg-light"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasWithBothOptions"
                aria-controls="offcanvasWithBothOptions"
                aria-label="navbar-toggler"
              >
                <span style={{ fontSize: "12px", marginLeft: "5px" }}>منو</span>
                <AiOutlineMenu />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="offcanvas offcanvas-end"
        data-bs-scroll="true"
        tabIndex={-1}
        id="offcanvasWithBothOptions"
        aria-labelledby="offcanvasWithBothOptionsLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasWithBothOptionsLabel">
            <span style={{ color: "red" }}>نیکوتن </span>سامانه جامع رزرو اماکن
            ورزشی
          </h5>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <div className="offcanvas-body">
          <div className="d-flex flex-column justify-content-between">
            <ul className="fs-6">
              {links.map((link, key) => {
                return (
                  <li className="p-2 border-bottom " key={key}>
                    <Link
                      to={link.path}
                      key={link.path}
                      className=" justify-content-center align-items-center header-font-size"
                      type="button"
                      data-bs-dismiss="offcanvas"
                      aria-label="Close"
                    >
                      <i
                        className="fa fa-book "
                        style={{ marginLeft: "6px" }}
                      ></i>
                      {link.name}
                    </Link>
                  </li>
                );
              })}
              <li className="p-2 border-bottom d-flex">
                <Link
                  to={renderLink()}
                  className="d-flex justify-content-center align-items-center header-font-size"
                  type="button"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  {enderLinkText()["icon"]}

                  {enderLinkText()["txt"]}
                </Link>
              </li>
              {user_type === "admin" ? (
                ""
              ) : (
                <li className="p-2 border-bottom border-bottom ">
                  <Link
                    to={"/card"}
                    className="header-font-size"
                    type="button"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  >
                    <i
                      className="fal fa-shopping-bag "
                      style={{ marginLeft: "6px" }}
                    ></i>
                    سبد خرید
                  </Link>
                </li>
              )}
            </ul>
          </div>
          <div
            className="row text-center mt-2 pt-2"
            dir="ltr"
            style={{
              color: "white",
              backgroundColor: "#404040",
              fontSize: "10px",
            }}
          >
            <h6 style={{ margin: "0px", fontSize: "12px", fontWeight: "200" }}>
              تمامی حقوق مادی و معنوی این سایت متعلق به شرکت ویداسیستم ایرانیان
              می باشد
            </h6>
            <p>
              &copy; 2015{" "}
              <a
                style={{ padding: "0px", margin: "0px" }}
                href="http://vidasystemiranian.co.ir"
              >
                Vida System Iranian
              </a>
            </p>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
